import { Injectable, Inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {
	UserService,
	userServiceToken
} from 'go-modules/models/user/user.service';
import { appDataServiceToken, AppDataService } from 'dashboard/services/app-data.service';

@Injectable({
	providedIn: 'root'
})
export class LicenseManagementGuard implements CanActivate {
	constructor (
		@Inject(appDataServiceToken) private appDataService: AppDataService,
		@Inject(userServiceToken) private userService: UserService,
		private router: Router
	) {}

	public canActivate (): Observable<boolean> {
		// Guards run before resolvers so we need this here too
		return from(this.appDataService.initAppData()).pipe(
			map(() => {
				const isGoReactPartner = this.appDataService.partners.every(
					(value) => value.guid === 'GO_REACT'
				);

				const isAuthorized =
					this.userService.currentUser.isInstructor ||
					this.userService.currentUser.is_root_user;

				if (!isAuthorized || !isGoReactPartner) {
					this.router.navigate(['/dashboard']);
					return false;
				}

				return true;
			}),
			catchError(() => {
				this.router.navigate(['/dashboard']);
				return of(false);
			})
		);
	}
}
